import { Star, Quote } from 'lucide-react';

const TESTIMONIALS = [
  {
    quote: "I finally sent the email I'd been drafting in my head for three months. My coach helped me realize I was catastrophizing the response — it took one session.",
    name: "Sarah K.",
    role: "Marketing Manager",
    topic: "Career anxiety",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&h=80&fit=crop&crop=face"
  },
  {
    quote: "I've tried journaling apps, meditation apps, therapy. This is the first thing that actually gives me a next step instead of just making me feel heard.",
    name: "Marcus T.",
    role: "Software Engineer",
    topic: "Overthinking",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80&h=80&fit=crop&crop=face"
  },
  {
    quote: "The coach remembered what I mentioned two weeks ago about my sister. No other app does that. It feels like talking to someone who actually knows you.",
    name: "Priya M.",
    role: "Grad Student",
    topic: "Relationships",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=80&h=80&fit=crop&crop=face"
  },
  {
    quote: "I used to spend Sunday nights anxious about the week ahead. Now I spend 10 minutes with my coach and I actually feel ready. Game changer.",
    name: "James O.",
    role: "Operations Lead",
    topic: "Work stress",
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=80&h=80&fit=crop&crop=face"
  },
  {
    quote: "I was skeptical — another AI thing. But it pushed back when I gave a vague goal and helped me get specific. That accountability is exactly what I needed.",
    name: "Rachel D.",
    role: "Freelance Designer",
    topic: "Goal setting",
    avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=80&h=80&fit=crop&crop=face"
  },
  {
    quote: "Cheaper than one therapy session per month, and I can use it every single day. For someone on a tight budget trying to grow, it's a no-brainer.",
    name: "Dani R.",
    role: "Recent Graduate",
    topic: "Personal growth",
    avatar: "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=80&h=80&fit=crop&crop=face"
  }
];

export function Testimonials() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-1 mb-4">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="h-5 w-5 text-amber-400 fill-amber-400" />
            ))}
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-slate-900 mb-3">
            Real people. Real progress.
          </h2>
          <p className="text-lg text-slate-600 max-w-xl mx-auto">
            Not before-and-after photos. Just honest accounts of what changed when people stopped overthinking and started taking action.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={i}
              className="bg-slate-50 rounded-2xl p-6 border border-slate-100 hover:border-slate-200 hover:shadow-md transition-all duration-200 flex flex-col"
            >
              <Quote className="h-6 w-6 text-coral-200 mb-4 flex-shrink-0" />
              <p className="text-slate-700 text-sm leading-relaxed flex-1 mb-5">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-slate-200">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                />
                <div className="min-w-0">
                  <p className="font-semibold text-slate-900 text-sm">{t.name}</p>
                  <p className="text-xs text-slate-500">{t.role}</p>
                </div>
                <span className="ml-auto text-xs px-2.5 py-1 bg-coral-50 text-coral-600 rounded-full font-medium flex-shrink-0">
                  {t.topic}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
